import fetchJson from './issue-view-as-json.tsx';

const appendOperationQuery = (operation?: string) => (operation ? `?operation=${operation}` : '');

export const getGiraUrl = (operation?: string): string =>
	`/rest/gira/1/${appendOperationQuery(operation)}`;

export type GiraQuery<_R> = string;
const makeFetchClient = (path: string) => ({
	query: <T,>({
		query,
		variables,
		signal,
		operationName,
	}: {
		query: GiraQuery<T>;
		variables: unknown;
		signal?: AbortSignal;
		operationName?: string;
	}): Promise<T> =>
		fetchJson(
			getGiraUrl(operationName),
			{
				method: 'POST',
				body: JSON.stringify({
					query,
					variables,
					operationName,
				}),
				signal,
			},
			path,
		),
});

let client: ReturnType<typeof makeFetchClient>;
export const getClient = (path: string) => {
	if (!client) {
		client = makeFetchClient(path);
	}

	return client;
};
